import { render, staticRenderFns } from "./settingsMenu.vue?vue&type=template&id=6c2b5750&"
import script from "./settingsMenu.vue?vue&type=script&lang=js&"
export * from "./settingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./settingsMenu.vue?vue&type=style&index=0&id=6c2b5750&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports